<script>
	// Upload one photo per color of a model (saved in agents_product_color_images).
	import { createEventDispatcher } from 'svelte';
	import { systemUrl } from '../api.js';
	import UserStore from '../stores/user';
	import { imgUrl, swatch } from '../lib/format';
	import Icon from './Icon.svelte';

	export let product;
	export let colors = [];

	const dispatch = createEventDispatcher();
	let busy = '';
	let error = '';

	const imageOf = (c) => {
		const img = (product.colorImages || []).find((i) => i.color === c);
		return img ? imgUrl(img.image_url) : '';
	};

	async function upload(color, file) {
		if (!file) return;
		busy = color;
		error = '';
		try {
			const fd = new FormData();
			fd.append('sku', product.sku);
			fd.append('color', color);
			fd.append('file', file);
			const res = await fetch(systemUrl + 'agents_upload_image_color?token=' + $UserStore.data, { method: 'POST', body: fd });
			const data = await res.json();
			if (!data.success) throw new Error('upload failed');
			const others = (product.colorImages || []).filter((i) => i.color !== color);
			product = { ...product, colorImages: [...others, { color, image_url: data.image_url }] };
			dispatch('updated', product);
		} catch (e) {
			error = 'ההעלאה נכשלה. אפשר להעלות JPG, PNG או WEBP.';
		}
		busy = '';
	}
</script>

<div class="backdrop over-sheet" on:click={() => dispatch('close')} />
<div class="modal" role="dialog" aria-label="תמונות לפי צבע">
	<div class="modal-head">
		<h2>תמונות · {(product.name || '').trim()}</h2>
		<button class="icon-btn" on:click={() => dispatch('close')} aria-label="סגירה"><Icon name="close" /></button>
	</div>
	<div class="modal-body">
		{#if error}<div class="alert-error">{error}</div>{/if}
		{#each colors as c}
			<div class="row">
				<span class="sw" style="background:{swatch(c)}" />
				<span class="name">{c || 'ללא צבע'}</span>
				<div class="pic">{#if imageOf(c)}<img src={imageOf(c)} alt="" />{:else}<span class="muted">אין</span>{/if}</div>
				<label class="btn-ghost small">
					{busy === c ? 'מעלה…' : imageOf(c) ? 'החלפה' : 'העלאה'}
					<input type="file" accept="image/jpeg,image/png,image/webp" hidden disabled={!!busy}
						on:change={(e) => upload(c, e.target.files[0])} />
				</label>
			</div>
		{/each}
	</div>
</div>

<style>
	.row { display: flex; align-items: center; gap: 14px; padding: 10px 0; border-bottom: 1px solid var(--line); }
	.row:last-child { border-bottom: 0; }
	.name { flex: 1; font-weight: 700; }
	.pic { width: 54px; aspect-ratio: 3 / 4; border-radius: 8px; overflow: hidden; background: var(--photo); display: grid; place-items: center; font-size: 12px; }
	.pic img { width: 100%; height: 100%; object-fit: cover; }
	label { cursor: pointer; }
	.alert-error { margin-bottom: 10px; }
</style>
